import React from 'react';
import {H3, Regular, LargePrimaryButton} from '@worthy-npm/clarity'
import {imageUrl, isMobile} from 'helpers/ApplicationHelper'
import CalendlyHelper from 'lib/calendly';

const ComingSoon = (props) => {
    return (
        <div className='coming-soon'>
            <div className='top-section'>
                <div className='cover-image w-100'>
                    <img className='w-100' alt='misplaced-diamind'
                         src={imageUrl(`experts/${isMobile()? 'comingSoonMobile' : 'comingSoonDesktop'}.svg`)}/>
                </div>
                <div className='text-container'>
                    <H3 text='Coming Soon...'/>
                    <Regular text='We’re working on adding this content as we speak, so stay tuned!'/>
                </div>
            </div>
            <div className='bottom-section'>
                <Regular overrideCSS={{color: '#4F4F4F', marginBottom: '20px'}}
                         text='Meanwhile our experts would be happy to answer any question you may have.'/>
                <LargePrimaryButton overrideWrapperCSS={{width: '100%'}}
                                    overrideCSS={{borderRadius: '2px', width: '100%'}}
                                    text='Book Consultation'
                                    click={(stopAnimation)=>{
                                        props.click()
                                        CalendlyHelper.showPopupWidget()
                                        stopAnimation()
                                    }}/>
            </div>
        </div>
    );
}

export default ComingSoon;